export const defaultHotkeys = {
  a: {
    name: "A",
    key: "a",
  },
  d: {
    name: "D",
    key: "d",
  },
  s: {
    name: "S",
    key: "s",
  },
  f: {
    name: "F",
    key: "f",
  },
  v: {
    name: "V",
    key: "v",
  },
  y: {
    name: "Y",
    key: "y",
  },
  decline: {
    name: "N",
    key: "n",
  },
  n: {
    name: "N",
    key: "n",
  },
  m: {
    name: "M",
    key: "m",
  },
  move: {
    name: "1",
    key: "1",
  },
  autoIrisCircle: {
    name: "2",
    key: "2",
  },
  box: {
    name: "3",
    key: "3",
  },
  polygon: {
    name: "4",
    key: "4",
  },
  segmentation: {
    name: "5",
    key: "5",
  },
  cuboid: {
    name: "6",
    key: "6",
  },
  ocr: {
    name: "7",
    key: "7",
  },
  polyline: {
    name: "8",
    key: "8",
  },
  showIndice: {
    name: "I",
    key: "i",
  },
  showIrisCircles: {
    name: "C",
    key: "c",
  },
  showLines: {
    name: "L",
    key: "l",
  },
  ArrowLeft: {
    name: "Arrow Left",
    key: "ArrowLeft",
  },
  ArrowRight: {
    name: "Arrow Right",
    key: "ArrowRight",
  },
  ArrowUp: {
    name: "Arrow Up",
    key: "ArrowUp",
  },
  ArrowDown: {
    name: "Arrow Down",
    key: "ArrowDown",
  },
  Control: {
    name: "Ctrl",
    key: "Control",
  },
  Space: {
    name: "Space",
    key: " ",
  },
  Shift: {
    name: "Shift",
    key: "Shift",
  },
  Delete: {
    name: "Delete",
    key: "Delete",
  },
  Backspace: {
    name: "Backspace",
    key: "Backspace",
  },
  Escape: {
    name: "Escape",
    key: "Escape",
  },
  z: {
    name: "Z",
    key: "z",
  },
  w: {
    name: "W",
    key: "w",
  },
};
